import { CoupleForm } from '@/components/enc/couple-form';
import { useParams } from 'react-router-dom';

const EditPage = () => {
  const { id } = useParams<{ id: string }>();

  return <CoupleForm key={id} id={id} />;
};

export default EditPage;
